import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import {Apollo, Mutation} from "apollo-angular";
import { Maybe } from "graphql/jsutils/Maybe";
import { Exact, Idea, Scalars } from "src/generated/graphql";


export class IdeaAuthor {
    id: Scalars['ID'];
    area?: Maybe<Scalars['String']>;
    costCenter?: Maybe<Scalars['String']>;
    cpf?: Maybe<Scalars['String']>;
    createdAt: Scalars['DateTime'];
    email?: Maybe<Scalars['String']>;
    idea: Idea;
    jobRole?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    re: Scalars['String'];
};

export class UpdateIdeaAuthor {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};


export type UpdateIdeaAuthorMutationVariables = Exact<{
    input: UpdateIdeaAuthor;
}>;

export type UpdateIdeaAuthorMutation = {
    updateIdeaAuthor: { id: string; name?: string; };
};

export const UpdateIdeaAuthorDocument = gql`
  mutation UpdateIdeaAuthor($input: UpdateIdeaAuthorInput!) {
    updateIdeaAuthor(data: $input) {
      id
      name
      re
      area
      costCenter
      cpf
      email
      jobRole
    }
  }
`;

@Injectable({
    providedIn: "root",
  })
  export class UpdateIdeaAuthorGQL extends Mutation<
    UpdateIdeaAuthorMutation,
    UpdateIdeaAuthorMutationVariables
  > {
    document = UpdateIdeaAuthorDocument;
  
    constructor(apollo: Apollo) {
      super(apollo);
    }
}
  